import { ServiceStatus, ServiceWindowReadDto } from '../_generated/api/structure'
import ApiModel from './ApiModel'

export default class ServiceWindow extends ApiModel<ServiceWindowReadDto> {
    get id() {
        return this.data.id
    }

    get name() {
        return this.data.name
    }

    get referenceLink() {
        return `/service-window/${this.id}`
    }

    get canComplete() {
        return (
            !!this.data.nextService &&
            !this.data.isTerminal &&
            this.data.status !== ServiceStatus.Done
        )
    }
}
